import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../styles/components/header.css';
import iconPhone from '../assets/icons/header_phone.svg';
import iconMail from '../assets/icons/header_mail.svg';
import Dropdown from '../components/Dropdown';

export default function Header() {
    const [isMobile, setIsMobile] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1050);
        };

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleNavigation = (path, hash = "") => {
        navigate(path);
        closeMenu();
        
        if (hash) {
            setTimeout(() => {
                const target = document.getElementById(hash);
                if (target) {
                    target.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        }
    };
    

    return (
        <header className="header_content">
            {!isMobile && (
                <div className="header_main_div">
                    <div className="header_center">
                        <div className="header_content">
                            <img src={iconPhone} alt="icone téléphone" className="icon_bolder" />
                            <p className="header_text">+33 4 99 78 08 11</p>
                        </div>
                        <div className="header_content">
                            <img src={iconMail} alt="icone mail" className="header_icon" />
                            <p className="header_text">contact@lab-lin.com</p>
                        </div>
                    </div>
                    <button className="btn-trad" onClick={() => window.location.href = 'https://lab-lin.fr/'}>
                        Traduction FR
                    </button>
                </div>
            )}
            <div className={`header_box ${isScrolled ? "scrolled" : ""}`}>
                <div className="header_box_div">
                    <div
                        className="header_logo"
                        onClick={() => handleNavigation('/')}
                    ></div>
                    {!isMobile && (
                        <p
                            className="header_box_p"
                            onClick={() => handleNavigation('/notre-laboratoire')}
                        >
                            OUR LABORATORY
                        </p>
                    )}
                </div>
                {isMobile ? (
                    <>
                        <button className="menu-toggle" onClick={toggleMenu}>
                            ≡
                        </button>
                        <button className="btn-trad-mobile" onClick={() => window.location.href = 'https://lab-lin.fr/'}>
                            Traduction FR
                        </button>
                        {isMenuOpen && (
                            <div className="mobile_menu">
                                <h3>Nos ingrédients :</h3>
                                <ul>
                                    <li onClick={() => handleNavigation('/probiotiques')}>Probiotics VPRO</li>
                                    <li onClick={() => handleNavigation('/probiotiques')}>Postbiotics PROLIPO</li>
                                    <li onClick={() => handleNavigation('/liposomes')}>Liposomal technology</li>
                                    <li onClick={() => handleNavigation('/niosomes')}>niosomam technology cosmetics</li>
                                </ul>
                                <h3>Nos formules :</h3>
                                <ul>
                                    <li onClick={() => handleNavigation('/formule-marque-blanche')}>white-label</li>
                                    <li onClick={() => handleNavigation('/formule-sur-mesure')}>tailor-made</li>
                                </ul>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="header_box_div">
                        <Dropdown
                            btn={1}
                            label="OUR INGREDIENTS"
                            items={[
                                { label: "PROBIOTICS VPRO®", path: "/probiotiques", hash:"top" },
                                { label: "POSTBIOTIQUCS PROLIPO®", path: "/probiotiques", hash: "postbiotique_positifPoint-container-bg" },
                                { label: "LIPOSOMAL TECHNOLOGY®", path: "/liposomes" },
                                { label: "COSMÉTICS", path: "/niosomes" }
                            ]}
                            onItemClick={handleNavigation}
                        />

                        <Dropdown
                            btn={2}
                            label="OUR OPTIONS"
                            items={[
                                { label: "WHITE-LABEL", path: '/formule-marque-blanche' },
                                { label: "TAILOR-MADE", path: '/formule-sur-mesure' }
                            ]}
                            onItemClick={handleNavigation}
                        />
                    </div>
                )}
            </div>
        </header>
    );
}
